import React from 'react';

// An array of React components. There are 3. The first 2 are
//  the prev/next buttons, and the  3rd one is the dots.
const ChartSlideDecorators = [
    {
        component: React.createClass({
            render() {
                return (null)
            }
        }),
        position: 'CenterLeft'
    },
    {
        component: React.createClass({
            render() {
                return (null)
            }
        }),
        position: 'CenterRight'
    },
    {
        component: React.createClass({
            render() {
                var self = this;
                var indexes = this.getIndexes(self.props.slideCount, self.props.slidesToScroll);
                return (
                    <ul style={self.getListStyles()}>
                        {
                            indexes.map(function(index) {
                                return (
                                    // Here are the dots. You can see that they are <li> elements
                                    // within a <ul> element. The <li>'s each have a button inside.
                                    // Down below you'll find the getButtonStyles() function.
                                    <li style={self.getListItemStyles()} key={index}>
                                        <button
                                            style={self.getButtonStyles(self.props.currentSlide === index)}
                                            onClick={self.props.goToSlide.bind(null, index)}>
                                            &bull;
                                        </button>
                                    </li>
                                )
                            })
                        }
                    </ul>
                )
            },
            getIndexes(count, inc) {
                var arr = [];
                for (var i = 0; i < count; i += inc) {
                    arr.push(i);
                }
                return arr;
            },
            getListStyles() {
                return {
                    position: 'relative',
                    margin: 0,
                    top: +15,
                    padding: 0
                }
            },
            getListItemStyles() {
                return {
                    listStyleType: 'none',
                    display: 'inline-block'
                }
            },
            getButtonStyles(active) {
                return {
                    border: 0,
                    background: 'transparent',
                    color: 'black',
                    cursor: 'pointer',
                    // Here is your padding.
                    padding: 10,
                    outline: 0,
                    fontSize: 24,
                    opacity: active ? 1 : 0.5
                }
            }
        }),
        position: 'BottomCenter'
    }
];

export default ChartSlideDecorators;


// WEBPACK FOOTER //
// ./src/components/chart/ChartSliderDecorator.js